export default __webpack_public_path__ + "static/media/photo_gallery_2.278eed02.png";